import { render } from "./AppsRenderer.vue?vue&type=template&id=bf9b98ac&scoped=true"
import script from "./AppsRenderer.vue?vue&type=script&lang=js"
export * from "./AppsRenderer.vue?vue&type=script&lang=js"

import "./AppsRenderer.vue?vue&type=style&index=0&id=bf9b98ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9b98ac"]])

export default __exports__